import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/trend-buzz/:marketplace?/:country?/:timeframe?',
    name: 'trend-buzz',
    component: () => import('@/modules/trend-buzz/pages/TrendBuzz.vue'),
    meta: {
      title: 'eRank Trend Buzz — Top keywords on Etsy, Amazon and more.',
      metaTags: [
        {
          name: 'description',
          content: 'See the top trending keywords on Etsy, Amazon, eBay, Google Shopping, Facebook Marketplace, Pinterest, Walmart, Depop, Poshmark, AliExpress and more.',
        },
        {
          name: 'title',
          content: 'eRank Trend Buzz — Top keywords on Etsy, Amazon and more.',
        },
        {
          name: 'og:title',
          content: 'eRank Trend Buzz — Top keywords on Etsy, Amazon and more.',
        },
        {
          name: 'og:description',
          content: 'See the top trending keywords on Etsy, Amazon, eBay, Google Shopping, Facebook Marketplace, Pinterest, Walmart, Depop, Poshmark, AliExpress and more.',
        },
        {
          name: 'og:site_name',
          content: 'eRank',
        },
        {
          name: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:title',
          content: 'eRank Trend Buzz — Top keywords on Etsy, Amazon and more.',
        },
        {
          name: 'twitter:description',
          content: 'See the top trending keywords on Etsy, Amazon, eBay, Google Shopping, Facebook Marketplace, Pinterest, Walmart, Depop, Poshmark, AliExpress and more.',
        },
        {
          name: 'twitter:image',
          content: '/img/erank-meta.png',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'p:domain_verify',
          content: '4a452b9edfa7318bd9a45fe0d20a25c0',
        },
        {
          name: 'google-site-verification',
          content: '-2cfMO7MeRJeifFFxsIOq3Ifssa2ai61ngBq40DYYkM',
        },
        {
          name: 'msvalidate.01',
          content: '65CFA6CFB407B1A92CCA3F3FB7B1D174',
        },
        {
          name: 'msapplication-TileColor',
          content: '#da532c',
        },
        {
          name: 'msapplication-config',
          content: '/favicons/browserconfig.xml',
        },
        {
          name: 'theme-color',
          content: '#ffffff',
        },
        {
          name: 'apple-mobile-web-app-capable',
          content: 'yes',
        },
        {
          name: 'mobile-web-app-capable',
          content: 'yes',
        },
        {
          page_slug: 'trend-buzz',
        },
      ],
    },
  },
];

export default routes;
